import { render, staticRenderFns } from "./ConversationWrap.vue?vue&type=template&id=1544136e&scoped=true&"
import script from "./ConversationWrap.vue?vue&type=script&lang=js&"
export * from "./ConversationWrap.vue?vue&type=script&lang=js&"
import style0 from "./ConversationWrap.vue?vue&type=style&index=0&id=1544136e&scoped=true&lang=scss&"
import style1 from "./ConversationWrap.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1544136e",
  null
  
)

export default component.exports